"use client";
import { Children } from "react";
//#region packages/@mantine/core/src/components/Group/filter-falsy-children/filter-falsy-children.ts
function filterFalsyChildren(children) {
	return Children.toArray(children).filter(Boolean);
}
//#endregion
export { filterFalsyChildren };

//# sourceMappingURL=filter-falsy-children.mjs.map